module.exports = __webpack_public_path__ + "img/error.4199e2b7.svg";